exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "", ""]);

// exports
exports.locals = {
	"ingleprimary": "#004687",
	"inglesecondary": "#f07d00",
	"rimiprimary": "#3a17c5",
	"rimisecondary": "#3a17c5",
	"msgprimary": "#961a1a",
	"msgsecondary": "#961a1a",
	"visitcanadaprimary": "#3498DB",
	"visitcanadasecondary": "#3498DB",
	"insurecanadaprimary": "#146ab5",
	"insurecanadasecondary": "#146ab5"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader?outputStyle=expanded!./src/styles/_colors.scss
// module id = 1090
// module chunks = 0